import { render, staticRenderFns } from "./PaddingControl.vue?vue&type=template&id=21a08490&scoped=true&"
import script from "./PaddingControl.vue?vue&type=script&lang=js&"
export * from "./PaddingControl.vue?vue&type=script&lang=js&"
import style0 from "./PaddingControl.vue?vue&type=style&index=0&id=21a08490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a08490",
  null
  
)

export default component.exports